import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useRef } from 'react'
import { Button } from '@guillotinaweb/react-gmi'

const ERRORS = {
  failed_to_fetch: 'Failed to fetch data: Backend not running?',
  invalid_credentials: 'Failed! Invalid credentials',
}

export function Login({ auth }) {
  const [username, setUser] = useState('')
  const [password, setPass] = useState('')
  const [errors, setErrors] = useState(undefined)
  const [loading, setLoading] = useState(false)
  const ref = useRef()

  useEffect(() => {
    ref.current.focus()
  }, [])

  const doLogin = async (ev) => {
    ev.preventDefault()
    if (username === '' || password === '') {
      setErrors('invalid_credentials')
      return
    }
    setLoading(true)
    try {
      await auth.login(username, password)
    } catch {
      setErrors('invalid_credentials')
    }
    setLoading(false)
  }

  return (
    <React.Fragment>
      <form className="login__form" action="" onSubmit={doLogin}>
        <div className="field">
          <label className="label">Username:</label>
          <input
            type="text"
            className="input"
            placeholder="Username"
            onChange={(ev) => setUser(ev.target.value)}
            value={username}
            ref={ref}
          />
        </div>
        <div className="field">
          <label className="label">Password:</label>
          <input
            type="password"
            className="input"
            onChange={(ev) => setPass(ev.target.value)}
            value={password}
          />
        </div>
        <div className="field">
          <Button className="is-warning" loading={loading}>
            Login
          </Button>
        </div>
        <div className="field">
          {errors && (
            <p className="has-text-danger">
              {ERRORS[errors] || 'Generic error'}
            </p>
          )}
        </div>
      </form>
    </React.Fragment>
  )
}
